import { z } from 'zod';
import { defineCallable } from './callable-contract';
import { ConflictMatchSchema, ConflictResultSchema } from './conflict';

// ---------------------------------------------------------------------------
// runConflictCheck
// ---------------------------------------------------------------------------

export const RunConflictCheckPayloadSchema = z.object({
  sessionId: z.string().min(1),
  organizationId: z.string().min(1),
});
export type RunConflictCheckPayload = z.infer<typeof RunConflictCheckPayloadSchema>;

export const runConflictCheckContract = defineCallable('runConflictCheck', {
  input: RunConflictCheckPayloadSchema,
  output: ConflictResultSchema,
});

// ---------------------------------------------------------------------------
// searchContacts
// ---------------------------------------------------------------------------

export const SearchContactsPayloadSchema = z.object({
  organizationId: z.string().min(1),
  query: z.string().min(2).max(200),
});
export type SearchContactsPayload = z.infer<typeof SearchContactsPayloadSchema>;

export const QueryTypeSchema = z.enum(['email', 'phone', 'name']);
export type QueryType = z.infer<typeof QueryTypeSchema>;

export const SearchContactsResultSchema = z.object({
  matches: z.array(ConflictMatchSchema),
  totalRecordsSearched: z.number().int().nonnegative(),
  queryType: QueryTypeSchema,
});
export type SearchContactsResult = z.infer<typeof SearchContactsResultSchema>;

export const searchContactsContract = defineCallable('searchContacts', {
  input: SearchContactsPayloadSchema,
  output: SearchContactsResultSchema,
});
